// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3SEFU","footer":"ModalInfo_footer__3a4fh"};